<template>
  <div :class="$options.name">
    <slot />
  </div>
</template>
<script lang="ts">
import { lateinit } from 'tg-commons'
import { ControlPosition, CustomControl, type StringEnumValue, unwrapStringEnumValue } from 'tg-map-core'
import { defineComponent } from 'vue'
import { type Props, safeAsComponent, stringEnumProp } from '../../utils/vue-utils'
import MapMixin from '../map-mixin'
import TgMap from '../TgMap.vue'

export default defineComponent({
  name: 'tg-custom-control',
  mixins: [MapMixin],
  props: {
    position: stringEnumProp(ControlPosition, ControlPosition.RIGHT_BOTTOM),
  } satisfies Props<{
    position: StringEnumValue<typeof ControlPosition>
  }>,
  setup() {
    return {
      control: lateinit<CustomControl>(),
    }
  },
  watch: {
    position() {
      this.recreate()
    },
  },
  onCreate() {
    if (!safeAsComponent(this.$parent, TgMap)) {
      console.warn('请将tg-custom-control放到tg-map中')
    }
    const { $el } = this
    const C = class extends CustomControl {
      onCreateElement() {
        return $el as HTMLElement
      }
    }
    this.control = new C(unwrapStringEnumValue(this.position, ControlPosition))
    this.$map.addCustomControl(this.control)
  },
  onDestroy() {
    this.$map.removeCustomControl(this.control)
  },
})
</script>
<style lang="scss">
// 当作为tg-map的直接child时不显示
.tg-map > .tg-custom-control {
  display: none;
}
</style>
